import lnat from './content/lnat.json';
import tmua from './content/tmua.json';
import ucat from './content/ucat.json';
import esat from './content/esat.json';
import tara from './content/tara.json';
import oxbridge from './content/oxbridge.json';
import medicalschool from './content/medicalschool.json';
import degreeapprenticeship from './content/degreeapprenticeship.json';
import pathbuddy from './content/pathbuddy.json';
import { isPathbuddyHost } from '../../../config/eduHost';
import { stripAppBasename } from '../../../config/appBase';

export const FEATURE_SLUGS = ['chat', 'fluid', 'studio', 'apps', 'cases'];

export const EXAM_CONTENT = {
  lnat,
  tmua,
  ucat,
  esat,
  tara,
  oxbridge,
  medicalschool,
  degreeapprenticeship,
  pathbuddy,
};

const EXAM_KEYS = Object.keys(EXAM_CONTENT).filter((k) => k !== 'pathbuddy');

export function getExamKeyFromHost() {
  if (typeof window === 'undefined') return 'lnat';
  // pathbuddy.com only — leave edu.ivori.ai and exam subdomains on their own packs.
  if (isPathbuddyHost()) return 'pathbuddy';
  const h = window.location.hostname.toLowerCase();
  for (const key of EXAM_KEYS) {
    if (h.startsWith(key) || h.includes(`${key}.`)) return key;
  }
  const path = stripAppBasename(window.location.pathname).toLowerCase();
  for (const key of EXAM_KEYS) {
    if (path === `/${key}` || path.startsWith(`/${key}/`) || path.startsWith(`/${key}-`)) {
      return key;
    }
  }
  return 'lnat';
}

export function getExamContent(examKey = getExamKeyFromHost()) {
  return EXAM_CONTENT[examKey] || EXAM_CONTENT.lnat;
}

export function getExamHomePath(examKey = getExamKeyFromHost()) {
  if (examKey === 'pathbuddy') return '/';
  if (typeof window === 'undefined') return `/${examKey}`;
  const h = window.location.hostname.toLowerCase();
  if (h.startsWith(examKey) || h.includes(`${examKey}.`)) return '/';
  return `/${examKey}`;
}

export function getExamMethodPath(examKey = getExamKeyFromHost()) {
  return `/method/${examKey}`;
}

export function getExamSiteOrigin(examKey = getExamKeyFromHost()) {
  if (examKey === 'pathbuddy') return 'https://pathbuddy.com';
  return `https://${examKey}.edu.ivoriai.com`;
}

/** Rewrite prototype HTML anchors into data-nav attributes for React routing. */
export function rewriteEditorialHtml(html) {
  if (!html) return '';
  return html
    .replace(/\sonclick="[^"]*"/g, '')
    .replace(/href="javascript:void\(0\)"/g, 'href="#"')
    .replace(
      /style="color:var\(--olive\); border-bottom:1px solid var\(--olive-25\);"/g,
      'class="lnat-ed-inline-link"'
    )
    .replace(/data-page="\/#plans"/g, 'data-nav="plans"')
    .replace(/data-page="\/method"/g, 'data-nav="method"')
    .replace(/data-page="\/"/g, 'data-nav="home"')
    .replace(/data-page="(\/insights\/[^"]+)"/g, 'data-nav="$1"')
    .replace(/data-page="(\/insights)"/g, 'data-nav="$1"');
}
